import { createAsyncThunk } from '@reduxjs/toolkit';

import { billAPI } from '@/modules/bill/api';
import { namespace } from '@/modules/bill/namespace';

import { setUpcomingBill } from '../actions';

const loadUpcomingBill = createAsyncThunk(
  `${namespace}/load-upcoming-bill`,
  async (_, { dispatch }) => {
    const upcomingBill = await billAPI.fetchUpcomingBill();

    dispatch(setUpcomingBill(upcomingBill));

    return upcomingBill;
  },
);

export { loadUpcomingBill };
